const initialReducer = {};

const initReducer = {
    ...initialReducer,
};

export default (state, action) => {
    return initReducer[action.type](state, action);
};
